module.exports = __webpack_public_path__ + "img/fu.519f2108.png";